
export default {
    employeeCount: [
        { text: "1 - 5", value: "1_-_5" },
        { text: "6 - 10", value: "6_-_10" },
        { text: "11 - 20", value: "11_-_20" },
        { text: "20 - 50", value: "20_-_50" },
        { text: "50 or more", value: "50_or_more" },
    ],
}